import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

// Configuração do Firebase
// Substitua pelos valores do seu projeto Firebase
const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY || "",
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN || "",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID || "",
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET || "",
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID || "",
  appId: process.env.VUE_APP_FIREBASE_APP_ID || "",
};

// Verificar se as configurações estão presentes
if (!firebaseConfig.apiKey || !firebaseConfig.projectId) {
  console.warn("⚠️ Firebase não configurado corretamente. Verifique as variáveis de ambiente.");
}

// Inicializar Firebase apenas se ainda não foi inicializado
if (!firebase.apps.length) {
  try {
    firebase.initializeApp(firebaseConfig);
    console.log("✅ Firebase inicializado com sucesso. Project ID:", firebaseConfig.projectId);
  } catch (error) {
    console.error("❌ Erro ao inicializar Firebase:", error);
    throw error;
  }
}

// Exportar instância do Firestore
export const db = firebase.firestore();

// Verificar conexão com Firestore
db.enablePersistence().catch((err: any) => {
  if (err.code === "failed-precondition") {
    console.warn("⚠️ Firestore persistence falhou: Múltiplas abas abertas");
  } else if (err.code === "unimplemented") {
    console.warn("⚠️ Firestore persistence não suportado neste navegador");
  } else {
    console.warn("⚠️ Firestore persistence error:", err);
  }
});

export default firebase;

